export default __webpack_public_path__ + "static/media/s5_stage_transition.0488de79.riv";